/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type {RecordSupportAssistantQuestionRequest} from '../models/RecordSupportAssistantQuestionRequest';
import type {SupportAssistantQuestionResponse} from '../models/SupportAssistantQuestionResponse';
import type {CancelablePromise} from '../core/CancelablePromise';
import type {BaseHttpRequest} from '../core/BaseHttpRequest';
export class SupportAssistantQuestionService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Records a captured Support Assistant question.
   * @returns SupportAssistantQuestionResponse Created
   * @throws ApiError
   */
  public supportAssistantQuestionRecord({
    requestBody,
  }: {
    requestBody: RecordSupportAssistantQuestionRequest;
  }): CancelablePromise<SupportAssistantQuestionResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/support-assistant-questions',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
      },
    });
  }
}
